import React, { useEffect, Component } from 'react';
import { X, AlertTriangle, Package, MapPin, CheckCircle, Tag, Check } from 'lucide-react';
import { Offer } from '../data/offers';
import { WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
interface OfferModalProps {
  offer: Offer | null;
  onClose: () => void;
}
export function OfferModal({
  offer,
  onClose
}: OfferModalProps) {
  // Lock body scroll when open
  useEffect(() => {
    if (offer) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [offer]);
  // Close on ESC
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  if (!offer) return null;
  const discount = Math.round((offer.originalPrice - offer.offerPrice) / offer.originalPrice * 100);
  const isCombo = offer.includes.length > 0;
  const waLink = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(offer.waMessage)}`;
  return <div className="fixed inset-0 bg-black/90 z-[9999] overflow-y-auto p-[30px_20px] backdrop-blur-sm flex items-start justify-center" onClick={e => {
    if (e.target === e.currentTarget) onClose();
  }} data-id="element-234" data-mp="2udjjhaed8dtq">
      <div className="bg-dark-600 border-2 border-[#ff3b30]/50 rounded-xl max-w-[780px] w-full overflow-hidden relative m-auto animate-modal-in" data-id="element-235" data-mp="349wa1zem6bk9">
        <button onClick={onClose} className="absolute top-[15px] right-[20px] bg-transparent border-none text-white text-[2rem] cursor-pointer z-20 leading-none transition-colors duration-200 hover:text-[#ff3b30]" aria-label="Cerrar" data-id="element-236" data-mp="3e10qz4nuo6hq">
          <X size={32} data-id="element-237" data-mp="3mzm5moq7b1d8" />
        </button>

        <div className="w-full h-[320px] bg-white flex items-center justify-center overflow-hidden relative" data-id="element-238" data-mp="3i3ncyoxuax70">
          <div className="absolute top-4 left-4 bg-[#ff3b30] text-white text-sm font-black w-14 h-14 rounded-full flex items-center justify-center z-10 shadow-lg rotate-6" data-id="element-239" data-mp="2fqiqbpaxoy09">
            -{discount}%
          </div>
          <img src={offer.image} alt={offer.name} className="w-full h-full object-contain p-[30px]" data-id="element-240" data-mp="2ookzis4tmwym" />
        </div>

        <div className="p-[35px]" data-id="element-241" data-mp="2yggzk8qgwx5h">
          <div className="inline-flex items-center gap-1.5 bg-[#ff3b30] text-white text-[0.75rem] font-extrabold py-1 px-3.5 rounded-sm tracking-[2px] uppercase mb-[15px]" data-id="element-242" data-mp="2yffkzua8tsj0">
            <Tag className="w-3.5 h-3.5" data-id="element-243" data-mp="38dveg3wqtdvo" /> Oferta Imperdible
          </div>

          <h2 className="text-[1.6rem] font-black uppercase tracking-[2px] text-white mb-[15px]" data-id="element-244" data-mp="3cfgl37ioovxf">
            {offer.name}
          </h2>

          {isCombo && <div className="bg-[#1e1e1e] rounded-lg p-4 mb-5" data-id="element-245" data-mp="1e26vzrrayt6j">
              <h4 className="text-[#ff3b30] text-[0.8rem] uppercase tracking-[2px] mb-3 font-bold flex items-center gap-2" data-id="element-246" data-mp="1i2qr6psbfmq1">
                <Package className="w-4 h-4" data-id="element-247" data-mp="1ajhhevfwdm0g" /> Este combo incluye
              </h4>
              <ul className="space-y-2" data-id="element-248" data-mp="15qofefbtcrs2">
                {offer.includes.map((item, idx) => <li key={idx} className="flex items-start gap-2 text-[#ddd] text-[0.9rem] font-medium" data-id="element-249" data-mp="10t6g7gnllqx9" data-mpi={idx}>
                    <Check className="w-4 h-4 text-[#ff3b30] shrink-0 mt-0.5" data-id="element-250" data-mp="1thke7weosn8t" />
                    <span data-id="element-251" data-mp="1ohxztjn4h0yf">{item}</span>
                  </li>)}
              </ul>
            </div>}

          <div className="bg-[#ff3b30]/10 border-l-4 border-l-[#ff3b30] p-[18px_20px] mb-5 rounded-r" data-id="element-252" data-mp="1kfkv8yk43938">
            <h4 className="text-[#ff3b30] text-[0.85rem] uppercase tracking-[2px] mb-2 font-bold flex items-center gap-2" data-id="element-253" data-mp="1fi2hmuv5g5ow">
              <AlertTriangle className="w-4 h-4" data-id="element-254" data-mp="92s67vipgyqv" /> El Problema que Resuelve
            </h4>
            <p className="text-[#ccc] text-[0.92rem] leading-[1.7]" data-id="element-255" data-mp="41b6w4fvdkce">
              {offer.pain}
            </p>
          </div>

          <p className="text-[#aaa] leading-[1.8] text-[0.97rem] mb-[25px]" data-id="element-256" data-mp="1rwpgjgaktvu8">
            {offer.description}
          </p>

          <p className="text-[0.85rem] uppercase tracking-[2px] text-[#666] mb-3 font-bold flex items-center gap-2" data-id="element-257" data-mp="1iy45e67fpj3h">
            <CheckCircle className="w-4 h-4 text-[#ff3b30]" data-id="element-258" data-mp="1mz7iwm20f31j" /> BENEFICIOS CLAVE
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-[25px]" data-id="element-259" data-mp="2aos29622s2bc">
            {offer.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2.5 bg-[#1e1e1e] p-3 rounded" data-id="element-260" data-mp="2fn3dnl80qkvo" data-mpi={idx}>
                <span className="text-[#ff3b30] font-black text-[1rem] flex-shrink-0 mt-px" data-id="element-261" data-mp="21qy5xv4b98o6">
                  ✓
                </span>
                <span className="text-[#ccc] text-[0.85rem] leading-[1.5]" data-id="element-262" data-mp="q96w2sl7awmv">
                  {benefit}
                </span>
              </div>)}
          </div>

          <div className="flex items-center gap-5 mb-[25px] flex-wrap" data-id="element-263" data-mp="mriy0g9kz45w">
            <span className="text-[1rem] text-[#555] line-through" data-id="element-264" data-mp="mtlvtmgz61l6">
              ${offer.originalPrice.toLocaleString('es-UY')}
            </span>
            <span className="text-[2.5rem] font-black text-[#ff3b30]" data-id="element-265" data-mp="wpymscl4y1c8">
              ${offer.offerPrice.toLocaleString('es-UY')}
            </span>
            <span className="bg-[#ff3b30]/15 border border-[#ff3b30]/40 text-[#ff7a73] text-[0.85rem] font-extrabold py-1.5 px-4 rounded-full" data-id="element-266" data-mp="roj24lmvdwud">
              AHORRÁS ${offer.savings.toLocaleString('es-UY')}
            </span>
          </div>

          <div className="bg-[#ff3b30]/10 border border-[#ff3b30]/25 rounded p-[14px_18px] mb-5 text-[0.88rem] text-[#ff3b30] font-semibold text-center flex items-center justify-center gap-2" data-id="element-267" data-mp="drcn9259oiaf">
            <AlertTriangle className="w-4 h-4" data-id="element-268" data-mp="3hfnyigqjl70p" /> Stock limitado · Esta oferta
            puede terminar en cualquier momento
          </div>

          <div className="bg-dark-500 border border-dark-300 rounded p-[15px_18px] mb-5 text-[0.85rem] text-[#999] space-y-2" data-id="element-269" data-mp="3cgbes4uywg2c">
            <div className="flex items-start gap-2" data-id="element-270" data-mp="1gbvliuxz323u">
              <Package className="w-4 h-4 mt-0.5 text-[#ff3b30] flex-shrink-0" data-id="element-271" data-mp="1lbrgk4oozj79" />
              <span data-id="element-272" data-mp="1q2zr541rdam0">
                <strong className="text-white" data-id="element-273" data-mp="1q4sw8ewq3mrw">Envío a domicilio:</strong> desde
                $190 pesos uruguayos, varía según tu zona
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-274" data-mp="xfdjnkpetltv">
              <MapPin className="w-4 h-4 mt-0.5 text-[#ff3b30] flex-shrink-0" data-id="element-275" data-mp="xgx3fla9yf0e" />
              <span data-id="element-276" data-mp="12egr1bsv4450">
                <strong className="text-white" data-id="element-277" data-mp="12g1d0d142er9">Pick Up:</strong> Malvín,
                Montevideo
              </span>
            </div>
          </div>

          <a href={waLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-whatsapp text-white text-[1.05rem] font-extrabold py-[18px] px-[30px] rounded uppercase tracking-[1px] transition-all duration-300 w-full shadow-[0_6px_25px_rgba(37,211,102,0.3)] hover:bg-whatsappDark hover:scale-[1.02]" data-id="element-278" data-mp="1bevcqc9qnl91">
            <WhatsAppIcon className="w-6 h-6" data-id="element-279" data-mp="2rznkwq3czq0i" />
            Quiero Esta Oferta — Pedir por WhatsApp
          </a>
        </div>
      </div>
    </div>;
}